<gux-simple-toast *ngFor="let message of messages"
                  [attr.accent]="message.accent"
                  (guxdismiss)="onDismiss(message, $event)">
  <gux-icon *ngIf="message.icon"
            [attr.icon-name]="message.icon"
            slot="icon"
            decorative>
  </gux-icon>
  <div slot="message" class="text-container">{{message.text | translate}}</div>
</gux-simple-toast>
